/*
 * @Author: 张天昊
 * @Date: 2024-06-28 15:16:09
 * @LastEditTime: 2024-06-28 15:16:50
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/composables/useNavBarHeight.js
 */
import { ref, onMounted } from 'vue';
export function useNavBarHeight() {
  const navBarHeight = ref('0');
  onMounted(() => {
    navBarHeight.value = document.body.style.getPropertyValue(
      '--yyn-nav-bar-height'
    );
  });

  return {
    navBarHeight
  };
}
